import {Pipe, PipeTransform, Injectable} from '@angular/core';
@Pipe({
    name: 'hours'
})
@Injectable()
export class HoursPipe implements PipeTransform {
    transform(items: any, field: string, value: string): any {
        if (!items|| items == 0){
            return 0;
        }
        const itemsStr = items.toString();
        const parts = itemsStr.split('.'); let hoursPart = parseInt(parts[0], 10);
        let minutesPart = 0;
        if (parts.length > 1) {
            minutesPart = parseInt(parts[1].padEnd(2, '0'), 10);
            if (isNaN(minutesPart)) minutesPart = 0;
        }
        if (minutesPart >= 60) {
            hoursPart += Math.floor(minutesPart / 60);
            minutesPart = minutesPart % 60;
        }
        return `${hoursPart}h ${minutesPart}m`;
    }
}
